import { ISocialPlatform } from '@/interfaces/socials'

export const validSocialNetworks = [
  {
    name: ISocialPlatform.FACEBOOK,
    url: 'https://www.facebook.com/',
  },
  {
    name: ISocialPlatform.TWITTER,
    url: 'https://twitter.com/',
  },
  {
    name: ISocialPlatform.INSTAGRAM,
    url: 'https://www.instagram.com/',
  },
  {
    name: ISocialPlatform.TIKTOK,
    url: 'https://www.tiktok.com/',
  },
  {
    name: ISocialPlatform.YOUTUBE,
    url: 'https://www.youtube.com/',
  },
]

export const validateIsSocialUrl = (url: string): boolean => {
  const isValid = validSocialNetworks.some((social) => url.includes(social.url))
  return isValid
}
